import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";

import useStaffTasksV2 from "features/staff-tasks-v2/hooks/use-staff-tasks-v2.hook";

export default function TaskNotFound() {
  const { handleCloseTaskModal } = useStaffTasksV2();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "400px",
        textAlign: "center"
      }}
    >
      <Stack spacing={3} alignItems="center">
        <Typography
          variant="h5"
          sx={{
            color: grey[800],
            fontWeight: 600
          }}
        >
          Task Not Found
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: grey[600],
            maxWidth: "400px",
            lineHeight: 1.6
          }}
        >
          This task might have been deleted. If you opened this from a
          notification, the task may no longer exist
        </Typography>

        <Button
          variant="contained"
          onClick={handleCloseTaskModal}
          sx={{
            mt: 2,
            px: 3,
            py: 1
          }}
        >
          Close
        </Button>
      </Stack>
    </Box>
  );
}
